import { useState } from 'react';
import { ChevronLeft, ChevronRight, Package } from 'lucide-react';
import type { ProductMedia } from '../../types/products';

interface ProductGalleryProps {
  media: ProductMedia[];
  productName: string;
}

export function ProductGallery({ media, productName }: ProductGalleryProps) {
  const [activeIndex, setActiveIndex] = useState(0);

  const images = media.filter((m) => m.type === 'image');
  const videos = media.filter((m) => m.type === 'video');
  const allMedia = [...images, ...videos];

  if (allMedia.length === 0) {
    return (
      <div className="aspect-square bg-white dark:bg-slate-800 rounded-2xl flex items-center justify-center border border-gray-100 dark:border-slate-700">
        <Package className="w-24 h-24 text-gray-300 dark:text-slate-600" />
      </div>
    );
  }

  const activeMedia = allMedia[activeIndex];

  const handlePrev = () => {
    setActiveIndex((prev) => (prev === 0 ? allMedia.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setActiveIndex((prev) => (prev === allMedia.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className="relative aspect-square bg-white dark:bg-slate-800 rounded-2xl overflow-hidden border border-gray-100 dark:border-slate-700">
      {activeMedia.type === 'video' ? (
        <video
          src={activeMedia.url}
          controls
          className="w-full h-full object-contain"
          poster={images[0]?.url}
        />
      ) : (
        <img
          src={activeMedia.url}
          alt={activeMedia.alt || productName}
          className="w-full h-full object-contain"
        />
      )}

      {/* Navigation Arrows */}
      {allMedia.length > 1 && (
        <>
          <button
            onClick={handlePrev}
            className="absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 bg-white/90 dark:bg-slate-700/90 hover:bg-white dark:hover:bg-slate-600 rounded-full flex items-center justify-center shadow-lg transition-all"
          >
            <ChevronLeft className="w-5 h-5 text-gray-700 dark:text-slate-300" />
          </button>
          <button
            onClick={handleNext}
            className="absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 bg-white/90 dark:bg-slate-700/90 hover:bg-white dark:hover:bg-slate-600 rounded-full flex items-center justify-center shadow-lg transition-all"
          >
            <ChevronRight className="w-5 h-5 text-gray-700 dark:text-slate-300" />
          </button>
        </>
      )}
    </div>
  );
}
